import { Box, Card, CardContent, Typography } from '@mui/material';

import { IService } from '../../models/api/entities';

interface Props {
    services: IService[];
}

const Services = ({ services }: Props) => (
    <Box sx={{ pt: 5 }}>
        {services.map((service) => (
            <Card sx={{ minWidth: 275, mb: 3 }}>
                <CardContent>
                    <Typography variant="h5" component="div">
                        {service.name}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        {service.duration} minute(s)
                    </Typography>
                    <Typography variant="body2">{service.description}</Typography>
                </CardContent>
            </Card>
        ))}
    </Box>
);

export default Services;
